import { Helmet } from "react-helmet";
import { useEffect, useState } from "react";
import trash from "../../asset/images/trash.png";

import SerHeader from "../serviceheader";
import arrowleft from "../../asset/images/arrowleftcircle.svg";
import UploadInvoice from "../uploadinvoice";
import UploadModal from "../uploadModal";
import Uploaddocumentfinance from "../uploadloaddocument";
import Loaders from "../loader";
import NG from "../../asset/images/NG.png";

import { useNavigate } from "react-router-dom";
import axios from "axios";
import ConfirmInvoice from "../confirmInvoice";
import FailHandler from "../failhandler";
import CurrencyModal from "../currencyModal";
import currencyPairCheck from "../../utilities/currencyPairCheck";
import Input from "component/form/Input";
import { ENDPOINTS } from "constants/endpoints";
import AssignSupplier from "./AssignSupplier";
import { useSelector } from "react-redux";
import { InfoCircleIcon } from "asset/icons";

const FlexInvoiceFlex = () => {
    const navigate = useNavigate();
    const [show, setShow] = useState(false);
    const [selecteditem, setselecteditem] = useState();
    const [filename, setfilename] = useState(null);
    const [filesize, setfilesize] = useState(0);
    const [aggreement, setagrrement] = useState(null);
    const [aggreementsize, setaggreementsize] = useState(0);
    const [showModal, setshowModal] = useState(false);
    const [showModal2, setshowModal2] = useState(false);
    const [showModal3, setshowModal3] = useState(false);
    const [ys, setys] = useState([]);
    const [months] = useState([]);
    const [m, getm] = useState(new Date().getMonth());
    const [y] = useState(new Date().getFullYear());
    const [showcurrency, setshowcurrency] = useState(false);
    const [subtotal, setsubtotal] = useState(0);
    const [invoiceTitle, setinvoiceTitle] = useState("");
    const [currency, setcurrency] = useState("");
    const [issuedate, setissuedate] = useState();
    const [duedate, setduedate] = useState();
    const [loader, setloader] = useState(false);
    const [note, setnote] = useState("");
    const [businessname, setbusinessname] = useState("");
    const [fails, setfails] = useState(false);
    const [message, setmessage] = useState("");
    const { business } = useSelector((state) => state);
    const [selectedSupplier, setSelectedSupplier] = useState();
    const [items, setitems] = useState([
        {
            itemName: "",
            quantity: 0,
            pricePerUnit: 0,
        },
    ]);
    const defaultCurrency = {
        img: NG,
        name: "NGN",
    };

    const [selectedcurrency, setselectedcurrency] = useState(defaultCurrency);

    const [daysofms] = useState(["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"]);

    const totalAmount = items.reduce((curr, item) => {
        return (curr = parseInt(curr) + parseInt(item.pricePerUnit * item.quantity));
    }, 0);

    const validateAllItemsTitle = items.every((item) => item.itemName.length > 2);

    const minimumAmountBaseOnCurrency = {
        GBP: 1,
        NGN: 9000,
        USD: 1,
    };

    const MINIMUM_AMOUNT =
        minimumAmountBaseOnCurrency[
            selectedcurrency?.length === 0 ? "NGN" : selectedcurrency.name
        ] || 5;
    const isValidAmount = MINIMUM_AMOUNT < totalAmount;

    const isDisabled =
        !invoiceTitle ||
        !issuedate ||
        !duedate ||
        !selectedSupplier ||
        !isValidAmount ||
        !validateAllItemsTitle;

    const handleClose = () => setShow(false);
    const addseletedcurrency = (currency) => {
        const newState = items.map((obj) => {
            return {
                ...obj,
                // currency: currency.title,
            };
        });
        setitems(newState);

        setshowcurrency(!showcurrency);

        setselectedcurrency(currency);
    };

    const updateitemitems = (e, indexs) => {
        const newState = items.map((obj, index) => {
            if (index === indexs) {
                return {
                    ...obj,
                    itemName: e.target.value,
                };
            }
            return obj;
        });

        setitems(newState);
    };
    const updateitemquantity = (e, indexs, p) => {
        const newState = items.map((obj, index) => {
            if (index === indexs) {
                return {
                    ...obj,
                    quantity: e.target.value,
                    // amount: e.target.value * p,
                };
            }
            return obj;
        });

        setitems(newState);
    };

    const updateitemprice = (e, indexs, q) => {
        const newState = items.map((obj, index) => {
            if (index === indexs) {
                return {
                    ...obj,
                    pricePerUnit: e.target.value,
                    // amount: q * e.target.value,
                };
            }
            return obj;
        });

        setitems(newState);
    };
    const addAnotherSection = () => {
        const data = {
            itemName: "",
            quantity: 0,
            pricePerUnit: 0,
        };
        setitems((current) => [...current, data]);
    };
    const delitems = (index) => {
        setitems([...items.slice(0, index)]);
    };
    useEffect(() => {
        if (fails) {
            let timer = setTimeout(() => {
                setfails(false);
            }, 3000);

            return () => {
                clearTimeout(timer);
            };
        }
    });

    const handleSubmitInvoice = async () => {
        setloader(true);
        const data = {
            userType: "BUYER",
            currency: selectedcurrency.length === 0 ? "NGN" : selectedcurrency.name,
            issueDate: issuedate,
            dueDate: duedate,
            invoiceTitle: invoiceTitle,
            invoiceItems: [...items],
            flexUser: selectedSupplier?._id,
        };

        await axios
            .post(ENDPOINTS.createInvoice, data)
            .then(() => {
                setloader(false);
                navigate(`/flex/success`, {
                    state: {
                        ...data,
                    },
                });
            })
            .catch((e) => {
                setfails(true);
                setloader(false);

                setmessage(e.response.data ? e.response.data.message : "An error occurred");
            });
    };

    useEffect(() => {
        setsubtotal(items.reduce((a, v) => (a = a + v.pricePerUnit * v.quantity), 0));
        const daysInMonth = new Date(y, m, 0).getDate();
        for (let i = 1; i <= daysInMonth; i++) {
            months.push(i);
        }
        const range = (start, stop, step) =>
            Array.from(
                {
                    length: (stop - start) / step + 1,
                },
                (_, i) => start + i * step
            );
        setys(range(y, y - 50, -1));
    }, [setys, m, y, months, daysofms, items]);

    return (
        <div className="h-100 w-100 ">
            <div
                className=""
                style={{
                    maxWidth: "2000px",
                    width: "100%",
                    margin: "0px auto",
                }}
            >
                <Helmet>
                    <title>Tradevu-invoice</title>
                </Helmet>

                <SerHeader header={"New Invoice"} isbtn={false} />
                <ConfirmInvoice
                    subtotal={subtotal}
                    currency={selectedcurrency.name}
                    selecteditem={selecteditem}
                    show={showModal3}
                    loader={loader}
                    setloader={setloader}
                    setshow={setshowModal3}
                    handleSubmitInvoice={handleSubmitInvoice}
                    showPreview={true}
                />
                <CurrencyModal
                    show={showcurrency}
                    setshow={setshowcurrency}
                    setcurrency={setcurrency}
                    addseletedcurrency={addseletedcurrency}
                />
                <Uploaddocumentfinance
                    show={showModal2}
                    setshow={setshowModal2}
                    filename={aggreement}
                    filesize={aggreementsize}
                    setfilesize={setaggreementsize}
                    setfilename={setagrrement}
                />
                <UploadModal
                    filesize={filesize}
                    show={showModal}
                    setshow={setshowModal}
                    filename={filename}
                    setfilesize={setfilesize}
                    setfilename={setfilename}
                />
            </div>
            <div style={{ height: "100%" }}>
                <div className="conatiner max-w-[2000px] mx-auto p-4 px-6 py-2.5">
                    <div className="flex justify-center w-100 h-100">
                        <UploadInvoice
                            show={show}
                            handle={handleClose}
                            selecteditem={selecteditem}
                            setselecteditem={setselecteditem}
                            setbusinessname={setbusinessname}
                        />
                        <form
                            onSubmit={handleSubmitInvoice}
                            style={{
                                maxWidth: "800px",
                                width: "100%",
                                position: "relative",
                            }}
                        >
                            <FailHandler message={message} success={fails} />
                            <div className="flex flex-col gap-8">
                                <div className="max-w-[592px] w-full mt-[50px] flex flex-col justify-between gap-8">
                                    <div className="flex flex-col gap-8">
                                        <div className="flex flex-col gap-4">
                                            <div
                                                onClick={() => {
                                                    navigate(-1);
                                                }}
                                            >
                                                <img src={arrowleft} alt="" />
                                            </div>
                                            <div className="text-[#101828] font-medium text-[24px] leading-[32.4px]">
                                                Create Invoice
                                            </div>
                                        </div>
                                        <div className="flex flex-col gap-6">
                                            {/* <PartnerSelectBtn
                                                handleShow={handleShow}
                                                label="Buyer"
                                                partner={selecteditem}
                                                subLabel="Enter buyer’s details"
                                            /> */}
                                            <AssignSupplier
                                                business={business}
                                                selectedSupplier={selectedSupplier}
                                                setSelectedSupplier={setSelectedSupplier}
                                                type={"buyer"}
                                                label="Buyer"
                                                subLabel="Enter buyer’s details"
                                            />

                                            <div className="flex flex-col gap-2">
                                                <label
                                                    htmlFor=""
                                                    style={{
                                                        color: "#344054",
                                                        fontWeight: "500",
                                                        lineHeight: "19.6px",
                                                        fontSize: "14px",
                                                    }}
                                                >
                                                    Invoice title
                                                </label>
                                                <div className="gap-2">
                                                    <input
                                                        type="text"
                                                        name=""
                                                        id=""
                                                        onChange={(e) => {
                                                            setinvoiceTitle(e.target.value);
                                                        }}
                                                        value={invoiceTitle}
                                                        placeholder="Invoice title"
                                                        className="customInput"
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="flex flex-col gap-2">
                                                <label
                                                    htmlFor=""
                                                    style={{
                                                        color: "#344054",
                                                        fontWeight: "500",
                                                        lineHeight: "19.6px",
                                                        fontSize: "14px",
                                                    }}
                                                >
                                                    Currency
                                                </label>

                                                <div style={{ gap: "8px" }}>
                                                    <div
                                                        onClick={() => {
                                                            setshowcurrency(!showcurrency);
                                                        }}
                                                        style={{
                                                            width: "100%",
                                                            maxWidth: "288px",
                                                            borderRadius: "8px",
                                                            border: "none",
                                                            outline: "none",
                                                            background: "",
                                                            padding: "8px 16px 8px 16px",
                                                            display: "flex",
                                                            backgroundColor: "#ECEFF3",
                                                            letterSpacing: "2%",
                                                            fontWeight: "500",
                                                            fontSize: "16px",
                                                            height: "56px",
                                                            justifyContent: "space-between",
                                                            position: "relative",
                                                            alignItems: "center",
                                                        }}
                                                    >
                                                        <div
                                                            style={{
                                                                display: "flex",
                                                                gap: "4px",
                                                                alignItems: "center",
                                                            }}
                                                        >
                                                            <img
                                                                src={selectedcurrency.img}
                                                                alt={selectedcurrency.name}
                                                                style={{
                                                                    width: "25px",
                                                                    height: "25px",
                                                                    border: "none",
                                                                }}
                                                            />
                                                            <span
                                                                style={{
                                                                    color: "#667085",
                                                                    fontSize: "16px",
                                                                    letterSpacing: "2%",
                                                                    lineHeight: "24px",
                                                                    fontWeight: "400",
                                                                }}
                                                            >
                                                                {selectedcurrency.name}
                                                            </span>
                                                        </div>
                                                        <span
                                                            className="material-icons"
                                                            style={{ color: "#101828" }}
                                                        >
                                                            keyboard_arrow_down
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="flex flex-col gap-2">
                                                <label
                                                    htmlFor=""
                                                    style={{
                                                        color: "#344054",
                                                        fontWeight: "500",
                                                        lineHeight: "19.6px",
                                                        fontSize: "14px",
                                                    }}
                                                >
                                                    Date
                                                </label>
                                                <div
                                                    style={{
                                                        gap: "16px",
                                                        display: "flex",
                                                    }}
                                                >
                                                    <Input
                                                        type="date"
                                                        placeholder="Issue date"
                                                        className="!text-base"
                                                        value={issuedate}
                                                        onChange={setissuedate}
                                                    />
                                                    <Input
                                                        type="date"
                                                        placeholder="Due date"
                                                        className="!text-base"
                                                        value={duedate}
                                                        onChange={setduedate}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {items.map((item, index) => (
                                    <div
                                        key={index}
                                        style={{
                                            display: "flex",
                                            gap: "32px",
                                        }}
                                    >
                                        <div
                                            className=""
                                            style={{
                                                display: "flex",
                                                gap: "8px",
                                                flexDirection: "column",
                                                maxWidth: "296px",
                                                width: "100%",
                                            }}
                                        >
                                            <label
                                                htmlFor=""
                                                style={{
                                                    color: "#344054",
                                                    fontWeight: "500",
                                                    lineHeight: "19.6px",
                                                    fontSize: "14px",
                                                }}
                                            >
                                                Items
                                            </label>
                                            <div style={{ gap: "8px" }}>
                                                <input
                                                    type="text"
                                                    name=""
                                                    id=""
                                                    required
                                                    onChange={(e) => updateitemitems(e, index)}
                                                    className="customInput"
                                                    placeholder="Add item name"
                                                />
                                            </div>
                                        </div>
                                        <div
                                            className=""
                                            style={{
                                                display: "flex",
                                                gap: "8px",
                                                flexDirection: "column",
                                                maxWidth: "120px",
                                                width: "100%",
                                            }}
                                        >
                                            <label
                                                htmlFor=""
                                                style={{
                                                    color: "#344054",
                                                    fontWeight: "500",
                                                    lineHeight: "19.6px",
                                                    fontSize: "14px",
                                                }}
                                            >
                                                Quantity
                                            </label>
                                            <div style={{ gap: "8px" }}>
                                                <input
                                                    type="number"
                                                    name=""
                                                    id=""
                                                    required
                                                    onChange={(e) =>
                                                        updateitemquantity(
                                                            e,
                                                            index,
                                                            item.pricePerUnit
                                                        )
                                                    }
                                                    className="customInput"
                                                    placeholder="1"
                                                />
                                            </div>
                                        </div>
                                        <div
                                            className=""
                                            style={{
                                                display: "flex",
                                                gap: "8px",
                                                flexDirection: "column",
                                                maxWidth: "120px",
                                                width: "100%",
                                            }}
                                        >
                                            <label
                                                htmlFor=""
                                                style={{
                                                    color: "#344054",
                                                    fontWeight: "500",
                                                    lineHeight: "19.6px",
                                                    fontSize: "14px",
                                                }}
                                            >
                                                Unit price
                                            </label>
                                            <div style={{ gap: "8px" }}>
                                                <input
                                                    type="number"
                                                    name=""
                                                    id=""
                                                    onChange={(e) =>
                                                        updateitemprice(e, index, item.quantity)
                                                    }
                                                    required
                                                    className="customInput"
                                                    placeholder="Unit price"
                                                />
                                            </div>
                                        </div>
                                        <div
                                            className=""
                                            style={{
                                                display: "flex",
                                                gap: "8px",
                                                flexDirection: "column",
                                                maxWidth: "120px",
                                                width: "100%",
                                            }}
                                        >
                                            <label
                                                htmlFor=""
                                                style={{
                                                    color: "#344054",
                                                    fontWeight: "500",
                                                    lineHeight: "19.6px",
                                                    fontSize: "14px",
                                                }}
                                            >
                                                Amount
                                            </label>
                                            <div
                                                style={{
                                                    gap: "8px",
                                                    display: "flex",
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        width: "100%",
                                                        borderRadius: "8px",
                                                        border: "none",
                                                        outline: "none",
                                                        background: "",
                                                        padding: "8px 0px 8px 0px",
                                                        letterSpacing: "2%",
                                                        fontWeight: "400",
                                                        fontSize: "16px",
                                                    }}
                                                >
                                                    {currencyPairCheck(
                                                        selectedcurrency?.length === 0
                                                            ? "NGN"
                                                            : selectedcurrency.name
                                                    )}
                                                    {parseFloat(
                                                        item.pricePerUnit *
                                                            item.quantity.toLocaleString("en-US", {
                                                                minimumFractionDigits: 2,
                                                            })
                                                    )}{" "}
                                                </div>
                                                {items.length > 1 && (
                                                    <div className="py-[10px] px-0">
                                                        <img
                                                            src={trash}
                                                            alt=""
                                                            style={{ cursor: "pointer" }}
                                                            onClick={() => {
                                                                delitems(index);
                                                            }}
                                                        />
                                                    </div>
                                                )}{" "}
                                            </div>
                                            <div></div>
                                        </div>
                                    </div>
                                ))}

                                <div className="flex flex-col gap-4">
                                    <div
                                        className="flex text-[#6F00FF] font-bold text-[14px] leading-5 tracking-[2%] items-center gap-8 cursor-pointer"
                                        onClick={addAnotherSection}
                                    >
                                        <span className="material-icons">add</span>
                                        Add another item
                                    </div>
                                    <div  className="p-2 !border-y border-dashed border-[#D7DDEA] flex justify-end">
                                        <div
                                            style={{
                                                maxWidth: "384px",
                                                width: "100%",
                                                display: "flex",
                                                flexDirection: "column",
                                                gap: "16px",
                                            }}
                                        >
                                            <div
                                                style={{
                                                    padding: "0px 0px 0px 60px",
                                                    display: "flex",
                                                    gap: "16px",
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        color: "#667085",
                                                        lineHeight: "24px",
                                                        fontSize: "16px",
                                                        fontWeight: "400",
                                                        textAlign: "center",
                                                        width: "100%",
                                                    }}
                                                >
                                                    Subtotal:
                                                </div>
                                                <div
                                                    style={{
                                                        color: "#101828",
                                                        fontSize: "16px",
                                                        letterSpacing: "2%",
                                                        fontWeight: "400",
                                                        lineHeight: "24px",
                                                        width: "100%",
                                                    }}
                                                >
                                                    {currencyPairCheck(
                                                        selectedcurrency?.length === 0
                                                            ? "NGN"
                                                            : selectedcurrency.name
                                                    )}
                                                    {parseFloat(subtotal).toLocaleString()}{" "}
                                                </div>
                                            </div>
                                            <div className="flex pr-0 pl-[30px] py-0 gap-2">
                                                <div>
                                                    <input
                                                        type="checkbox"
                                                        name=""
                                                        id=""
                                                        style={{
                                                            accentColor: "#6F00FF",
                                                            borderColor: "#6F00FF",
                                                            borderRadius: "16px",
                                                            clipPath: "circle(100% at 50% 50%)",
                                                        }}
                                                    />
                                                </div>
                                                <div
                                                    style={{
                                                        color: "#667085",
                                                        lineHeight: "24px",
                                                        fontSize: "16px",
                                                        fontWeight: "400",
                                                        width: "100%",
                                                        display: "flex",
                                                        alignItems: "center",
                                                    }}
                                                >
                                                    <div>Add Tax (7.5%):</div>
                                                </div>
                                                <div
                                                    style={{
                                                        color: "#101828",
                                                        fontSize: "16px",
                                                        letterSpacing: "2%",
                                                        fontWeight: "500",
                                                        lineHeight: "24px",
                                                        width: "100%",
                                                    }}
                                                >
                                                    <span style={{ marginLeft: "10px" }}>
                                                        {" "}
                                                        {currencyPairCheck(
                                                            selectedcurrency?.length === 0
                                                                ? "NGN"
                                                                : selectedcurrency.name
                                                        )}
                                                        {parseFloat(
                                                            0.075 * subtotal
                                                        ).toLocaleString()}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "end",
                                        marginTop: "-10px",
                                    }}
                                >
                                    <div
                                        style={{
                                            maxWidth: "384px",
                                            width: "100%",
                                            padding: "0px 0px 0px 60px",
                                            display: "flex",
                                        }}
                                    >
                                        <div
                                            style={{
                                                color: "#101828",
                                                lineHeight: "24.3px",
                                                fontSize: "18px",
                                                fontWeight: "500",
                                                textAlign: "center",
                                                width: "100%",
                                            }}
                                        >
                                            Total:
                                        </div>
                                        <div
                                            style={{
                                                color: !isValidAmount ? "crimson" : "#101828",
                                                lineHeight: "24.3px",
                                                fontSize: "18px",
                                                fontWeight: "500",
                                                width: "100%",
                                            }}
                                            className="flex items-center justify-start gap-2"
                                        >
                                            {currencyPairCheck(
                                                selectedcurrency?.length === 0
                                                    ? "NGN"
                                                    : selectedcurrency.name
                                            )}
                                            {parseFloat(
                                                parseFloat(subtotal) +
                                                    parseFloat(0.01 * subtotal) +
                                                    parseFloat(0.075 * subtotal)
                                            ).toLocaleString()}{" "}
                                            {!isValidAmount && (
                                                <span
                                                    title={`Total must be a minimum of ${currencyPairCheck(
                                                        selectedcurrency?.length === 0
                                                            ? "NGN"
                                                            : selectedcurrency.name
                                                    )}10000`}
                                                >
                                                    <InfoCircleIcon />
                                                </span>
                                            )}{" "}
                                        </div>
                                    </div>
                                </div>

                                <div
                                    style={{
                                        maxWidth: "592px",
                                        width: "100%",
                                    }}
                                >
                                    <div className="flex flex-col gap-2">
                                        <label
                                            htmlFor=""
                                            className="text-[#344054] font-medium text-[14px] leading-5"
                                        >
                                            Notes
                                        </label>
                                        <div style={{ gap: "8px" }}>
                                            <textarea
                                                type="text"
                                                name=""
                                                id=""
                                                onChange={(e) => {
                                                    setnote(e.target.value);
                                                }}
                                                value={note}
                                                className="customInput !h-[83px]"
                                                placeholder="Write a note here"
                                            ></textarea>
                                        </div>
                                    </div>
                                </div>
                                <div className="mb-5">
                                    <button
                                        type="button"
                                        onClick={() => {
                                            if (
                                                selectedcurrency.name === "NGN" &&
                                                subtotal < MINIMUM_AMOUNT
                                            ) {
                                                setfails(true);
                                                setmessage(
                                                    "Total amount of items should be more than or equal to ₦10,000"
                                                );
                                            } else {
                                                setshowModal3(true);
                                            }
                                        }}
                                        disabled={isDisabled}
                                        className={`w-[280px] ${
                                            isDisabled
                                                ? "bg-[#EBE4FF] text-[#BFA6FF]"
                                                : "bg-[#6F00FF] text-[#ffff]"
                                        } p-4 border-0 outline-0 rounded-[8px] flex justify-center items-center text-[16px] leading-6 tracking-[2%] font-medium`}
                                    >
                                        {loader === true ? <Loaders data={loader} /> : "Submit"}{" "}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FlexInvoiceFlex;
